module.exports = __webpack_public_path__ + "img/288.0fa6203d.png";